// Single source of truth for the DFTB26 Virtual Platform deep-link.
// Used by Program.jsx (home CTA), Watch.jsx (repurposed Replays tab) and
// Info.jsx (useful links). Update copy here and it propagates everywhere.

export const VIRTUAL_PLATFORM = {
  url: "https://virtual.dftb26.com",
  // Short hostname for buttons/links.
  host: "virtual.dftb26.com",
  // 1-line headline used on cards.
  headline: "On-demand replays of every DFTB26 talk",
  // Smaller supporting copy.
  subline: "Available now until June 2027",
  // Long-form explainer for the dedicated gateway page.
  description:
    "Every keynote, parallel session and workshop from DFTB26 is up on the virtual platform — watch back the talks you missed, share them with your team, and revisit the moments that hit hardest.",
  // What delegates need to do on first visit.
  login_note:
    "We've granted you access on virtual.dftb26.com, so sign up there using the same email you used here. You'll set your own password on that site.",
};
